import {
  FaConciergeBell,
  FaHamburger,
  FaPizzaSlice,
  FaUtensils,
} from "react-icons/fa";
import { GiContract, GiNoodles, GiTacos } from "react-icons/gi";
import { MdCleanHands, MdOutlineElectricalServices } from "react-icons/md";

const iconMap: Record<string, JSX.Element> = {
  FaUtensils: <FaUtensils />,
  FaHamburger: <FaHamburger />,
  FaPizzaSlice: <FaPizzaSlice />,
  FaConciergeBell: <FaConciergeBell />,
  GiContract: <GiContract />,
  GiNoodles: <GiNoodles />,
  GiTacos: <GiTacos />,
  MdOutlineElectricalServices: <MdOutlineElectricalServices />,
  MdCleanHands: <MdCleanHands />,
};

export const CatagoryList: Record<
  string,
  { name: string; icon: JSX.Element }[]
> = {
  Restaurants: [
    { name: "Takeout", icon: iconMap.FaUtensils },
    { name: "Burgers", icon: iconMap.FaHamburger },
    { name: "Chinese", icon: iconMap.GiNoodles },
    { name: "Italian", icon: iconMap.FaPizzaSlice },
    { name: "Reservation", icon: iconMap.FaConciergeBell },
    { name: "Delivery", icon: iconMap.GiTacos },
    { name: "Mexican", icon: iconMap.GiTacos },
  ],
  "Home Services": [
    { name: "Contractors", icon: iconMap.GiContract },
    { name: "Electricians", icon: iconMap.MdOutlineElectricalServices },
    { name: "Home Cleaner", icon: iconMap.MdCleanHands },
  ],
  Shopping: [], // Empty categories
  "Auto Services": [
    { name: "Auto Repair", icon: iconMap.GiContract },
    { name: "Auto Detailing", icon: iconMap.GiContract },
    { name: "Body Shops", icon: iconMap.GiContract },
    { name: "Car Wash", icon: iconMap.GiContract },
    { name: "Car Dealers", icon: iconMap.GiContract },
    { name: "Oil Change", icon: iconMap.GiContract },
    { name: "Parking", icon: iconMap.GiContract },
    { name: "Towing", icon: iconMap.GiContract },
  ],
  "Beauty & Health": [], // Empty categories
  Nightlife: [], // Empty categories
  "Active Life": [], // Empty categories
  More: [
    { name: "Coffee & Tea", icon: iconMap.FaUtensils },
    { name: "Bars", icon: iconMap.FaHamburger },
    { name: "Bakeries", icon: iconMap.FaPizzaSlice },
    { name: "Desserts", icon: iconMap.FaConciergeBell },
    { name: "Catering", icon: iconMap.GiTacos },
    { name: "Food Trucks", icon: iconMap.GiTacos },
    { name: "Grocery", icon: iconMap.GiTacos },
    { name: "Ice Cream & Frozen Yogurt", icon: iconMap.GiTacos },
    { name: "Juice Bars & Smoothies", icon: iconMap.GiTacos },
    { name: "Specialty Food", icon: iconMap.GiTacos },
    { name: "Beer, Wine & Spirits", icon: iconMap.GiTacos },
    { name: "Convenience Stores", icon: iconMap.GiTacos },
  ],
};
